// Libraries
import React from "react";
import {get} from "lodash";
import {reduxForm} from "redux-form";
import {compose} from "recompose";
import {connect} from "react-redux";

// Components
import BaseForm from 'components/Form';
import ODREV from "./ODREV";

// Services
import {ACTION_TYPE, SESSION_TYPE, signIn} from "services/session";

const Form = (): JSX.Element => {
  const onSubmit = (values: any) => {
    console.log("values", values);
  };

  return (
    <BaseForm
      onSubmit={onSubmit}
      name="odrev"
      autoComplete="off"
    >
      <ODREV />
    </BaseForm>
  )
};

const odrevForm = reduxForm<object, any>({
  form: "odrev",
  touchOnChange: true,
  enableReinitialize: true
})(Form);

const mapStateToProps = (state: object): object => ({
  session: get(state, 'session'),
  genders: get(state, 'options.genders'),
  roles: get(state, 'options.roles'),
  clientsStatuses: get(state, 'options.clients_statuses'),
  // formValues: get(state, 'form.user.values'),
  // initialValues: {
  //   actions: [null]
  // },
});

const mapDispatchToProps = (dispatch: (action: ACTION_TYPE) => any) => ({
  // Services
  signIn: (user: SESSION_TYPE) => dispatch(signIn(user)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(odrevForm);
